<template>
  <div>
    <el-form
        label-position="left"
        ref="form"
        :model="form"
        :disabled="disabledForm"
        size="mini">

        <el-row :gutter="10">
          <el-col :span="8" :offset="0" v-for="(item, index) in form.items" :key="index">
            <!-- <div >
              <el-form-item
                  :label-width="index === 0 ? '150px' : 0"
                  :label="index === 0 ? 'Payment Date *': ''"
                  :prop="'items.' + index + '.paidDate'"
                  :rules="{ required: index === 2 ? false : true, message: 'Field is required', trigger: 'blur' }">
                <el-date-picker
                    style="width: 100%;"
                    v-model="item.paidDate"
                    :clearable='false'
                    format="d MMM yy"
                    value-format="MM-dd-yyyy"
                    type="date"
                    placeholder="Select Date">
                </el-date-picker>
              </el-form-item>
            </div> -->
            <div >
              <el-form-item
                  :label-width="index === 0 ? '150px' : 0"
                  :label="index === 0 ? 'Payment Method *': ''"
                  :prop="'items.' + index + '.paymentMethodId'"
                  :rules="{ required: index === 2 ? false : true, message: 'Field is required', trigger: 'blur' }">
                <el-select
                    no-data-text="no date"
                    placeholder="Select Payment Method"
                    class="select"
                    v-model="item.paymentMethodId"
                    @change="changePaymentMethod(item)"
                >
                  <el-option
                      v-for="item in paymentMethodList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
            <div >
              <el-form-item
                :label-width="index === 0 ? '150px' : 0"
                :label="index === 0 ? 'Payment Account *': ''"
                :prop="'items.' + index + '.depositAccountId'"
                :rules="{ required: index === 2 ? false : true, message: 'Field is required', trigger: 'blur' }">
                <el-select
                    no-data-text="no date"
                    placeholder="Select Payment Account"
                    :disabled="!item.paymentMethodId"
                    class="select"
                    v-model="item.depositAccountId"
                >
                  <el-option
                      v-for="item in item.depositAccountList"
                      :key="item.id"
                      :disabled="!item.active"
                      :label="item.name"
                      :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
            <div >
              <el-form-item
                :label-width="index === 0 ? '150px' : 0"
                :label="index === 0 ? 'Amount Paid': ''"
                :prop="'items.' + index + '.amountPaid'"
                :rules="index === 2 ?
                { required: false, message: 'Field is required', trigger: 'blur' } :
                { validator: checkAmountPaid, trigger: 'blur' }">
                <money v-model="item.amountPaid" v-bind="money" @keydown.native="$event.key === '-' ? $event.preventDefault() : null" @change.native="$emit('calculateResults')"></money>
              </el-form-item>
            </div>
            <div >
              <el-form-item
                :label-width="index === 0 ? '150px' : 0"
                :label="index === 0 ? 'Balance to Pay': ''">
                <money :value="item.balanceToPay" v-bind="money" disabled></money>
              </el-form-item>
            </div>
            <div >
              <el-form-item
                :label-width="index === 0 ? '150px' : 0"
                :label="index === 0 ? 'Cheque / Ref #': ''"
                :prop="'items.' + index + '.chequeRefNo'">
                <el-input placeholder="Cheque Vaucher/Ref #" v-model="item.chequeRefNo">
                </el-input>
              </el-form-item>
            </div>

            <!-- <div>
              <el-form-item
                  label="Received By"
                  :prop="'items.' + index + '.paidBy'"
                  :rules="{ required: true, message: 'Field is required', trigger: 'blur' }">
                <el-select
                    no-data-text="no date"
                    placeholder="Received By"
                    class="select"
                    v-model="item.paidBy"
                >
                  <el-option
                      v-for="item in paidByListChanged"
                      :key="item.id"
                      :label="item.fullName"
                      :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </div> -->

            <!-- <div style="display: flex; align-items: center; min-width: 113px;">
              <el-button v-show="index > 1" size="mini" @click="deleteItem(index)">Delete</el-button>
            </div> -->

            <!-- <div style="display: flex; justify-content: flex-end; margin-top: 10px;">
              <el-button type="primary" size="mini" @click="add">Add New payment Line</el-button>
            </div> -->
          </el-col>
        </el-row>

      <div v-for="(item, index) in form.items"
           :key="index"
           style="display: flex; justify-content: space-between; gap: 10px;">
        <!-- <div >
          <el-form-item
              label="Payment Date"
              :prop="'items.' + index + '.paidDate'"
              :rules="{ required: true, message: 'Field is required', trigger: 'blur' }">
            <el-date-picker
                v-model="item.paidDate"
                :clearable='false'
                format="d MMM yy"
                value-format="MM-dd-yyyy"
                type="date"
                placeholder="Select Date">
            </el-date-picker>
          </el-form-item>
        </div>
        <div >
          <el-form-item
              label="Payment Method"
              :prop="'items.' + index + '.paymentMethodId'"
              :rules="{ required: true, message: 'Field is required', trigger: 'blur' }">
            <el-select
                no-data-text="no date"
                placeholder="Select Payment Method"
                class="select"
                v-model="item.paymentMethodId"
                @change="changePaymentMethod(item)"
            >
              <el-option
                  v-for="item in paymentMethodList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </div>
        <div >
          <el-form-item label="Payment Account" :prop="'items.' + index + '.depositAccountId'">
            <el-select
                no-data-text="no date"
                placeholder="Select Payment Account"
                :disabled="!item.paymentMethodId"
                class="select"
                v-model="item.depositAccountId"
            >
              <el-option
                  v-for="item in item.depositAccountList"
                  :key="item.id"
                  :disabled="!item.active"
                  :label="item.name"
                  :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </div>
        <div >
          <el-form-item label="Amount Paid" :prop="'items.' + index + '.amountPaid'">
            <money v-model="item.amountPaid" v-bind="money" @keydown.native="$event.key === '-' ? $event.preventDefault() : null" @change.native="$emit('calculateResults')"></money>
          </el-form-item>
        </div>
        <div >
          <el-form-item label="Balance to Pay">
            <money :value="item.balanceToPay" v-bind="money" disabled></money>
          </el-form-item>
        </div>
        <div >
          <el-form-item label="Cheque / Ref #" :prop="'items.' + index + '.chequeRefNo'">
            <el-input placeholder="Cheque Vaucher/Ref #" v-model="item.chequeRefNo">
            </el-input>
          </el-form-item>
        </div> -->
<!--        <div>-->
<!--          <el-form-item-->
<!--              label="Received By"-->
<!--              :prop="'items.' + index + '.paidBy'"-->
<!--              :rules="{ required: true, message: 'Field is required', trigger: 'blur' }">-->
<!--            <el-select-->
<!--                no-data-text="no date"-->
<!--                placeholder="Received By"-->
<!--                class="select"-->
<!--                v-model="item.paidBy"-->
<!--            >-->
<!--              <el-option-->
<!--                  v-for="item in paidByListChanged"-->
<!--                  :key="item.id"-->
<!--                  :label="item.fullName"-->
<!--                  :value="item.id">-->
<!--              </el-option>-->
<!--            </el-select>-->
<!--          </el-form-item>-->
<!--        </div>-->
        <!-- <div style="display: flex; align-items: center; min-width: 113px;">
          <el-button v-show="index > 1" size="mini" @click="deleteItem(index)">Delete</el-button>
        </div> -->
      </div>
    </el-form>
    <!-- <div style="display: flex; justify-content: flex-end; margin-top: 10px;">
      <el-button type="primary" size="mini" @click="add">Add New payment Line</el-button>
    </div> -->
  </div>
</template>

<script>
import { Money } from 'v-money'

export default {
  name: 'SplitsPaymentsMethodCD',
  components: {
    Money
  },
  data() {
    return {
      form: {
        items: [
          {
            // paidDate: null,
            paymentMethodId: null,
            depositAccountId: null,
            amountPaid: 0,
            balanceToPay: 0,
            chequeRefNo: null,
            // paidBy: null,
            depositAccountList: []
          },
          {
            // paidDate: null,
            paymentMethodId: null,
            depositAccountId: null,
            amountPaid: 0,
            balanceToPay: 0,
            chequeRefNo: null,
            // paidBy: null,
            depositAccountList: []
          },
          {
            // paidDate: null,
            paymentMethodId: null,
            depositAccountId: null,
            amountPaid: 0,
            balanceToPay: 0,
            chequeRefNo: null,
            // paidBy: null,
            depositAccountList: []
          }
        ]
      },
      money: {
        precision: 2,
        decimal: '.',
        thousands: ','
      },
    }
  },
  props: {
    paymentMethodList: {
      type: Array,
      default: () => ([])
    },
    disabledForm: {
      type: Boolean,
      default: false
    }
    // paidByList: {
    //   type: Array,
    //   default: () => ([])
    // }
  },
  // computed: {
  //   paidByListChanged() {
  //     return this.paidByList.filter(val => val.isChequeReceipts)
  //   }
  // },
  methods: {
    checkAmountPaid(rule, value, callback) {
      if (+value <= 0) {
        return callback(new Error('Please input the field'));
      } else callback();
    },
    add() {
      this.form.items.push(
        {
          paidDate: null,
          paymentMethodId: null,
          depositAccountId: null,
          amountPaid: 0,
          balanceToPay: 0,
          chequeRefNo: null,
          // paidBy: null,
          depositAccountList: []
        }
      )
    },
    deleteItem(i) {
      this.form.items = this.form.items.filter((val, index) => index !== i)
    },
    changePaymentMethod(item) {
      const pm = this.paymentMethodList.find(val => val.id === item.paymentMethodId)
      if (pm) {
        item.depositAccountList = pm.accounts
        item.depositAccountId = null
      } else {
        item.depositAccountList = []
        item.depositAccountId = null
      }
    },
    validate() {
      return new Promise((resolve) => {
        this.$refs.form.validate((valid) => {
          console.log('======', valid)
          resolve(valid)
        })
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.form {
  display: flex;
  gap: 20px;
}
/deep/.el-input {
  width: 100%;
}
// /deep/ .el-date-editor {
//   width: 150px !important;
// }
/deep/.label-without-start {
  :before {
    display: none;
  }
}
/deep/.el-form-item__label:before {
  display: none;
}
</style>